module.exports = __webpack_public_path__ + "static/img/bg_growyunma_bag.269dc096.png";